<template>
  <transition name="modal">
    <div class="modal-mask" @click="$emit('close')">
      <div class="modal-wrapper middle">
        <div class="modal-container" @click.stop>
          <button
            type="button"
            class="close close-corner"
            @click="$emit('close')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-header">
            <slot name="header"> </slot>
          </div>

          <div class="modal-body">
            <slot name="body"> </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-default" @click="$emit('close')">
                OK
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted: function () {
    let vm = this
    document.addEventListener('keydown', (e) => {
      if (e.keyCode == 27) {
        vm.$emit('close')
      }
    })
  }
}
</script>

<style scoped></style>
